export default {
    BASE_URL: 'wx/mm/shopping',
    api: [
        {
            name: 'detail',
            desc: '获取店铺详情',
            method: 'GET',
            path: 'storeDetail'
        }
    ]
}



// WEBPACK FOOTER //
// ./src/api/apis/mall/store.js